/**
 * Unpaid level 4 (blocked) confinement (TDD-5603): the tenant keeps its session
 * but every route is forced back to the unpaid invoices screen. Auth routes stay
 * reachable so logout / tenant switch / inaccessible-tenant pages keep working.
 */
export default defineNuxtRouteMiddleware((to) => {
    // useUnpaidStatus (not tenant.isUnpaidBlocked) so the local `unpaid-level`
    // forcing flag confines the app exactly like a real level 4.
    const { isBlocked } = useUnpaidStatus();

    if (!isBlocked.value) return;

    if (!isUnpaidConfinementExempt(to.path)) {
        useUnpaidTracking().setInvoicesSource('blocked_redirect');
        return navigateTo('/settings/invoices');
    }
});
